import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import 'jquery-slimscroll/jquery.slimscroll.min';
import PropTypes from "prop-types";
import {Badge} from 'reactstrap';
import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import UserRoles, {USER_DIRECTORY_ROLES} from "../../constants/UserRoles";
import Framework from "@beardeddevops/react.framework"

class SidebarContent extends React.Component {

	static propTypes = {
		regions: PropTypes.array,
		roles: PropTypes.array
	};

	constructor(props) {
		super(props);
		this.model = new API.BuildClass(Types.Accounts._name, API.RequestType.READ);

	}

	render() {
		const {roles, history} = this.props;
		return (
			<>
				{roles.includes(UserRoles.Onboarding) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/dataEntry'}
						parentId={'dataEntry'}
						parentIcon={'tachometer'}
						parentLinkText={'Data Entry'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
					/>
				}
				{roles.includes(UserRoles.Admin) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/admins'}
						parentId={'admins'}
						parentIcon={'tachometer'}
						parentLinkText={'Admin'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
						badge={this.props.badges.hasOwnProperty('new_hires')}
						badge_color={"danger"}
						badge_text={"!"}
					>
						<li>
							<Link data-cy={'av_keys'} variant={"text"} to="/admins/av_keys">
								<i className="fa fa-calendar"/>
								<span className="nav-text">AV Keys</span>
							</Link>
						</li>
						<li>
							<Link data-cy={'av_keys'} variant={"text"} to="/admins/auth_codes">
								<i className="fa fa-calendar"/>
								<span className="nav-text">Auth Codes</span>
							</Link>
						</li>
						<li>
							<Link data-cy={'gap_timers'} variant={"text"} to="/admins/gap_timers">
								<i className="fa fa-calendar"/>
								<span className="nav-text">Role Timeouts</span>
							</Link>
						</li>
						<li>
							<Link data-cy={'freshdesk_merge_subjects'} variant={"text"} to="/admins/freshdesk_merge_subjects">
								<i className="fa fa-filter"/>
								<span className="nav-text">FD Merge Filters</span>
							</Link>
						</li>
						<li>
							<Link data-cy={'kpi_metrics'} variant={"text"} to="/admins/kpi_metrics">
								<i className="fa fa-calendar"/>
								<span className="nav-text">KPI Metrics</span>
							</Link>
						</li>
						<li>
							<Link data-cy={'fe_metric_thresholds'} variant={"text"} to="/admins/fe_metric_thresholds">
								<i className="fa fa-line-chart"/>
								<span className="nav-text">FE Graph Floors</span>
							</Link>
						</li>
						<li>
							<Link data-cy={'engineer_scores'} variant={"text"} to="/admins/engineer_scores">
								<i className="fa fa-calendar"/>
								<span className="nav-text">Engineer Scores</span>
							</Link>
						</li>
						<li>
							<Link data-cy={'engineer_scores'} variant={"text"} to="/admins/new_hires">
								<i className="fa fa-calendar"/>
								<span className="nav-text">New Hires</span>
								<Badge style={{float: "right", position: "relative", top: "5px", marginLeft: "15px"}} color={'danger'} pill>
									{this.props.badges.hasOwnProperty('new_hires') ? this.props.badges.new_hires : ""}
								</Badge>
							</Link>
						</li>
						<li>
							<Link data-cy={'feedback_responses'} variant={"text"} to="/admins/feedback_responses">
								<i className="fa fa-comment"/>
								<span className="nav-text">Customer Feedback</span>
							</Link>
						</li>
						<li>
							<Link data-cy={'helpdesk_settings'} variant={"text"} to="/admins/helpdesk_settings">
								<i className="fa fa-phone"/>
								<span className="nav-text">Helpdesk Settings</span>
							</Link>
						</li>
					</Framework.Elements.NavGroup>
				}
				{roles.some(role => [UserRoles.FieldEngineer, UserRoles.Admin, UserRoles.Executive].includes(role)) && <Framework.Elements.NavGroup
					parentTextVarient={null}
					parentTargetPath={'/business_cards'}
					parentId={'business_cards'}
					parentIcon={'clipboard'}
					parentLinkText={'Business Cards'}
					history={history}
					path={history.location.pathname}
					default={'closed'}
					badge={this.props.badges.hasOwnProperty('pending_cards')}
					badge_color={"warning"}
					badge_text={this.props.badges?.pending_cards}
				/>}
				{roles.some(role => [UserRoles.Executive, UserRoles.Admin].includes(role)) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/executives'}
						parentId={'executives'}
						parentIcon={'tachometer'}
						parentLinkText={'Executives'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
					>
						<li>
							<Link data-cy={'fe_comparison'} variant={"text"} to="/executives/comparison">
								<i className="fa fa-calendar"/>
								<span className="nav-text">FE Comparison</span>
							</Link>
						</li>
						<li>
							<Link data-id={'dispatch'} variant={"text"} to="/executives/approvals">
								<i className="fa fa-book"/>
								<span className="nav-text">Contractor Schedules</span>
							</Link>
						</li>
					</Framework.Elements.NavGroup>
				}

				{roles.some(role => [UserRoles.Executive, UserRoles.Admin, UserRoles.Dispatch, UserRoles.HelpDesk, UserRoles.Hiring, UserRoles.Manager, UserRoles.Projects].includes(role)) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/projects'}
						parentId={'projects'}
						parentIcon={'tachometer'}
						parentLinkText={'Projects'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
					/>}

				{roles.some(role => [UserRoles.Feedback, UserRoles.Admin].includes(role)) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/feedback'}
						parentId={'feedback'}
						parentIcon={'tachometer'}
						parentLinkText={'Feedback'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
					/>}

				{roles.some(role => [UserRoles.Feedback, UserRoles.Admin, UserRoles.Collection].includes(role)) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/collections'}
						parentId={'collections'}
						parentIcon={'tachometer'}
						parentLinkText={'Collections'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
					/>}

				{roles.some(role => [UserRoles.Admin, UserRoles.Executive, UserRoles.Manager].includes(role)) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/managers'}
						parentId={'managers'}
						parentIcon={'tachometer'}
						parentLinkText={'Managers'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
					>

						{/*<li>*/}
						{/*	<Link data-cy={'engineer_scores'} variant={"text"} to="/managers/alerts">*/}
						{/*		<i className="fa fa-calendar"/>*/}
						{/*		<span className="nav-text">Alerts</span>*/}
						{/*	</Link>*/}
						{/*</li>*/}
						<li>
							<Link data-cy={'engineer_scores'} variant={"text"} to="/managers/tripfees">
								<i className="fa fa-calendar"/>
								<span className="nav-text">Trip Fee Zones</span>
							</Link>
						</li>
						<li>
							<Link data-cy={'kpi_scores'} variant={"text"} to="/managers/kpi_scores">
								<i className="fa fa-calendar"/>
								<span className="nav-text">KPI Scores</span>
							</Link>
						</li>
						<li>
							<Link data-cy={'kpi_scores'} variant={"text"} to="/managers/wos_worked">
								<i className="fa fa-calendar"/>
								<span className="nav-text">WO's Worked</span>
							</Link>
						</li>
						<li>
							<Link data-cy={'kpi_scores'} variant={"text"} to="/managers/rolling_tors">
								<i className="fa fa-calendar"/>
								<span className="nav-text">Rolling TORs</span>
							</Link>
						</li>
						<li>
							<Link data-cy={'kpi_scores'} variant={"text"} to="/managers/fe_estimates">
								<i className="fa fa-calendar"/>
								<span className="nav-text">Fe Weekly Estimates</span>
							</Link>
						</li>

						<>
							<Framework.Elements.NavGroup
								parentTextVarient={null}
								parentTargetPath={'/managers/time_tracking'}
								parentId={'dispatcher_time'}
								parentIcon={'tachometer'}
								parentLinkText={"Dispatcher's Time"}
								history={history}
								path={history.location.pathname}
								default={'closed'}
							>
								<li>
									<Link data-cy={'dispatch_calendar'} variant={"text"} to="/managers/time_tracking/daily_activities">
										<i className="fa fa-calendar"/>
										<span className="nav-text">Daily Activities</span>
									</Link>
								</li>
								<li>
									<Link data-cy={'dispatch_calendar'} variant={"text"} to="/managers/time_tracking/daily_gaps">
										<i className="fa fa-calendar"/>
										<span className="nav-text">Daily Gaps</span>
									</Link>
								</li>
							</Framework.Elements.NavGroup>
						</>
						<li>
							<Link variant={"text"} to="/managers/helpdesk_time_tracking">
								<i className="fa fa-calendar"/>
								<span className="nav-text">Helpdesk's Time</span>
							</Link>
						</li>
						<li>
							<Link variant={"text"} to="/managers/hiring_time_tracking">
								<i className="fa fa-calendar"/>
								<span className="nav-text">Hiring's Time</span>
							</Link>
						</li>
						<li>
							<Link data-cy={'av_center'} variant={"text"} to="/managers/av_center">
								<i className="fa fa-calendar"/>
								<span className="nav-text">AV Center</span>
							</Link>
						</li>
						<li>
							<Link data-cy={'automated_emails'} variant={"text"} to="/managers/automated_emails">
								<i className="fa fa-envelope"/>
								<span className="nav-text">Automated Emails</span>
							</Link>
						</li>
						<li>
							<Link data-cy={'kpi_scores'} variant={"text"} to="/managers/schedule_optimizations">
								<i className="fa fa-calendar"/>
								<span className="nav-text">Schedule Optimizations</span>
							</Link>
						</li>
						{/*<li>*/}
						{/*	<Link data-cy={'outstanding_invoices'} variant={"text"} to="/managers/outstanding_invoices">*/}
						{/*		<i className="fa fa-calendar"/>*/}
						{/*		<span className="nav-text">Outstanding Invoices</span>*/}
						{/*	</Link>*/}
						{/*</li>*/}
						<li>
							<Link data-id={'idle_admin'} variant={'text'} to="/managers/idle_tasks_admin">
								<i className="fa fa-archive"/>
								<span className="nav-text">Idle Tasks Admin</span>
							</Link>
						</li>
					</Framework.Elements.NavGroup>
				}

				{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.HelpDesk].includes(role)) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/dispatch'}
						parentId={'dispatch'}
						parentIcon={'tachometer'}
						parentLinkText={'Dispatch'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
					>
						<li>
							<Link data-cy={'dispatch_calendar'} variant={"text"} to="/dispatch/calendar">
								<i className="fa fa-calendar"/>
								<span className="nav-text">Calendar</span>
							</Link>
						</li>
						<li>
							<Link data-cy={'dispatch_active'} variant={"text"} to="/dispatch/active">
								<i className="fa fa-laptop"/>
								<span className="nav-text">Active Users</span>
							</Link>
						</li>
						<li>
							<Link data-cy={'booked'} variant={"text"} to="/dispatch/booked">
								<i className="fa fa-book"/>
								<span className="nav-text">Recently Booked</span>
							</Link>
						</li>
						<li>
							<Link data-cy={'fe_availability'} variant={"text"} to="/dispatch/availability">
								<i className="fa fa-laptop"/>
								<span className="nav-text">FE Availability</span>
							</Link>
						</li>
						<li>
							<Link data-cy={'fe_availability'} variant={"text"} to="/dispatch/ticketsstatus">
								<i className="fa fa-laptop"/>
								<span className="nav-text">Ticket Statuses</span>
							</Link>
						</li>
						<li>
							<Link data-cy={'daily_eta'} variant={"text"} to="/dispatch/daily_eta">
								<i className="fa fa-clock-o"/>
								<span className="nav-text">Daily ETA</span>
							</Link>
						</li>
						<li>
							<Link data-id={'calendar_logs'} variant={"text"} to="/dispatch/logs">
								<i className="fa fa-archive"/>
								<span className="nav-text">Calendar Logs</span>
							</Link>
						</li>
						<li>
							<Link data-id={'closest_fe'} variant={"text"} to="/dispatch/closest">
								<i className="fa fa-map"/>
								<span className="nav-text">Closest FE</span>
							</Link>
						</li>
						<li>
							<Link data-id={'closest_fe'} variant={"text"} to="/dispatch/mapped">
								<i className="fa fa-map"/>
								<span className="nav-text">Optimize Routes</span>
							</Link>
						</li>
						<li>
							<Link data-id={'felocation'} variant={"text"} to="/dispatch/felocation">
								<i className="fa fa-compass"/>
								<span className="nav-text">FE Locations</span>
							</Link>
						</li>
						<li>
							<Link data-id={'tforeschedule'} variant={'text'} to={'/dispatch/tfos'}>
								<i className={'fa fa-compass'}/>
								<span className={'nav-text'}>TFOs/Reschedules</span>
							</Link>
						</li>
						<li>
							<Link data-id={'reschedulefourth'} variant={'text'} to={'/dispatch/reschedulefourth'}>
								<i className={'fa fa-compass'}/>
								<span className={'nav-text'}>Fourth Reschedule</span>
							</Link>
						</li>
						<li>
							<Link data-id={'dispatchschedules'} variant={'text'} to={'/dispatch/dispatchschedules'}>
								<i className={'fa fa-compass'}/>
								<span className={'nav-text'}>Schedules</span>
							</Link>
						</li>
						<li>
							<Link data-id={'dispatch_idle_tasks'} variant={'text'} to="/dispatch/idle_tasks">
								<i className="fa fa-archive"/>
								<span className="nav-text">Idle Tasks</span>
							</Link>
						</li>
					</Framework.Elements.NavGroup>
				}

				{roles.includes(UserRoles.FieldEngineer) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/engineers/stats'}
						parentId={'engineerstats'}
						parentIcon={'tachometer'}
						parentLinkText={'Statistics'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
					/>
				}

				{roles.includes(UserRoles.FieldEngineer) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/engineers/worked'}
						parentId={'engineerworked'}
						parentIcon={'tachometer'}
						parentLinkText={'WOs Completed'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
					/>
				}

				{roles.includes(UserRoles.FieldEngineer) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/engineers'}
						parentId={'engineers'}
						parentIcon={'tachometer'}
						parentLinkText={'Field Engineers'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
					/>
				}

				{roles.includes(UserRoles.FieldEngineer) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/engineers/daily_eta'}
						parentId={'engineerdailyeta'}
						parentIcon={'clock-o'}
						parentLinkText={'Daily ETA'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
					/>
				}

				{roles.includes(UserRoles.FieldEngineer) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/engineers/approvals'}
						parentId={'engineerstats'}
						parentIcon={'tachometer'}
						parentLinkText={'Set Schedule'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
					/>
				}


				{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.HelpDesk].includes(role)) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/helpdesks'}
						parentId={'helpdesks'}
						parentIcon={'comments'}
						parentLinkText={'Helpdesk'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
						badge={this.props.badges.hasOwnProperty('pending_edits') || this.props.badges.hasOwnProperty('missing_financial')}
						badge_color={"danger"}
						badge_text={this.props.badges?.pending_edits || this.props.badges?.missing_financial}
					>
						{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.HelpDesk].includes(role)) ?
							<li>
								<Link data-id={'ticket_audit'} variant={'text'} to="/helpdesks/audit">
									<i className="fa fa-check-square"/>
									<span className="nav-text">Ticket Audit</span>
								</Link>
							</li> : null}
						{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.HelpDesk].includes(role)) ?
							<li>
								<Link data-id={'cash_check'} variant={'text'} to="/helpdesks/cash_check">
									<i className="fa fa-archive"/>
									<span className="nav-text">Cash/Check Financials</span>
								</Link>
							</li> : null}
						{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.HelpDesk].includes(role)) ?
							<li>
								<Link data-id={'cash_check'} variant={'text'} to="/helpdesks/random">
									<i className="fa fa-archive"/>
									<span className="nav-text">Random Ticket Review</span>
								</Link>
							</li> : null}
						{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.HelpDesk].includes(role)) ?
							<li>
								<Link data-id={'cash_check'} variant={'text'} to="/helpdesks/contacted">
									<i className="fa fa-archive"/>
									<span className="nav-text">Phone Calls</span>
								</Link>
							</li> : null}
						{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.HelpDesk].includes(role)) ?
							<li>
								<Link data-id={'cash_check'} variant={'text'} to="/helpdesks/unfiltered">
									<i className="fa fa-archive"/>
									<span className="nav-text">Unfiltered</span>
								</Link>
							</li> : null}
						{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.HelpDesk].includes(role)) ?
							<li>
								<Link data-id={'cash_check'} variant={'text'} to="/helpdesks/overrides">
									<i className="fa fa-archive"/>
									<span className="nav-text">Clear Codes</span>
								</Link>
							</li> : null}
						{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.HelpDesk].includes(role)) ?
							<li>
								<Link data-id={'fe_performance'} variant={'text'} to="/helpdesks/fe_performance">
									<i className="fa fa-line-chart"/>
									<span className="nav-text">FE Performance</span>
								</Link>
							</li> : null}
						{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.HelpDesk].includes(role)) ?
							<li>
								<Link data-id={'missing_financial'} variant={'text'} to="/helpdesks/missing_financial">
									<i className="fa fa-file-text"/>
									<span className="nav-text">Today Missing</span>
									<Badge style={{float: "right", position: "relative", top: "5px", marginLeft: "15px"}} color={'danger'} pill>
										{this.props.badges.hasOwnProperty('missing_financial') ? this.props.badges.missing_financial : ""}
									</Badge>
								</Link>
							</li> : null}
						{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.HelpDesk].includes(role)) ?
							<li>
								<Link data-id={'7_day_missing'} variant={'text'} to="/helpdesks/missing">
									<i className="fa fa-archive"/>
									<span className="nav-text">7 Day Missing</span>
								</Link>
							</li> : null}
						{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.HelpDesk].includes(role)) ?
							<li>
								<Link data-id={'helpdeskschedules'} variant={'text'} to={'/helpdesks/helpdeskschedules'}>
									<i className={'fa fa-compass'}/>
									<span className={'nav-text'}>Schedules</span>
								</Link>
							</li> : null}





						{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.HelpDesk, UserRoles.Executive].includes(role)) ?
							<li>
								<Link data-id={'financialedits'} variant={'text'} to={'/helpdesks/financialedits'}>
									<i className={'fa fa-compass'}/>
									<span className={'nav-text'}>Financial Edits</span>

									<Badge style={{float: "right", position: "relative", top: "5px", marginLeft: "15px"}} color={'danger'} pill>
										{this.props.badges.hasOwnProperty('pending_edits') ? this.props.badges.pending_edits : ""}
									</Badge>
								</Link>
							</li> : null}
					</Framework.Elements.NavGroup>
				}

				{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Hiring].includes(role)) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/hiring/heatmap'}
						parentId={'hiring'}
						parentIcon={'comments'}
						parentLinkText={'Hiring'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
					>
						<li>
							<Link data-cy={'zones'} variant={"text"} to="/hiring/hiring_zones">
								<i className="fa fa-calendar"/>
								<span className="nav-text">Hiring Zones</span>
							</Link>
						</li>
						<li>
							<Link data-id={'candidates'} variant={'text'} to="/hiring/search">
								<i className="fa fa-archive"/>
								<span className="nav-text">Candidate Search</span>
							</Link>
						</li>
						<li>
							<Link data-id={'candidates'} variant={'text'} to="/hiring/reach_out">
								<i className="fa fa-archive"/>
								<span className="nav-text">Reach Out</span>
							</Link>
						</li>
						<li>
							<Link data-id={'candidates'} variant={'text'} to="/hiring/pre_interview">
								<i className="fa fa-archive"/>
								<span className="nav-text">Pre-Interview</span>
							</Link>
						</li>
						<li>
							<Link data-id={'candidates'} variant={'text'} to="/hiring/scheduled_interview">
								<i className="fa fa-archive"/>
								<span className="nav-text">Scheduled Interview</span>
							</Link>
						</li>
						<li>
							<Link data-id={'candidates'} variant={'text'} to="/hiring/interviews">
								<i className="fa fa-archive"/>
								<span className="nav-text">Interviews</span>
							</Link>
						</li>
						<li>
							<Link data-id={'candidates'} variant={'text'} to="/hiring/offered_job">
								<i className="fa fa-archive"/>
								<span className="nav-text">Offered Job</span>
							</Link>
						</li>
						<li>
							<Link data-id={'candidates'} variant={'text'} to="/hiring/paperwork">
								<i className="fa fa-archive"/>
								<span className="nav-text">Waiting on Paperwork</span>
							</Link>
						</li>
						<li>
							<Link data-id={'candidates'} variant={'text'} to="/hiring/hired">
								<i className="fa fa-archive"/>
								<span className="nav-text">Hired</span>
							</Link>
						</li>
						<li>
							<Link data-id={'candidates'} variant={'text'} to="/hiring/actively">
								<i className="fa fa-archive"/>
								<span className="nav-text">Actively Working</span>
							</Link>
						</li>
						<li>
							<Link data-id={'candidates'} variant={'text'} to="/hiring/declined">
								<i className="fa fa-archive"/>
								<span className="nav-text">ServiceBookr Declined</span>
							</Link>
						</li>
						<li>
							<Link data-id={'candidates'} variant={'text'} to="/hiring/quit">
								<i className="fa fa-archive"/>
								<span className="nav-text">Quit</span>
							</Link>
						</li>
						<li>
							<Link data-id={'candidates'} variant={'text'} to="/hiring/hold">
								<i className="fa fa-archive"/>
								<span className="nav-text">Hold</span>
							</Link>
						</li>
						<li>
							<Link data-id={'hiringschedules'} variant={'text'} to={'/hiring/hiringschedules'}>
								<i className={'fa fa-compass'}/>
								<span className={'nav-text'}>Schedules</span>
							</Link>
						</li>

					</Framework.Elements.NavGroup>
				}

				{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.FieldEngineer, UserRoles.Developer, UserRoles.HelpDesk].includes(role)) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/tickets'}
						parentId={'tickets'}
						parentIcon={'ticket'}
						parentLinkText={'Tickets'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
					>
						{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.HelpDesk].includes(role)) ?
							<li>
								<Link data-id={'tickets_logs'} variant={'text'} to="/tickets/logs">
									<i className="fa fa-archive"/>
									<span className="nav-text">Tickets Logs</span>
								</Link>
							</li> : null}
					</Framework.Elements.NavGroup>
				}
				{/*Do like Users and control access in the route so we can set filters and whatnot*/}
				{!roles.includes(UserRoles.Onboarding) && <Framework.Elements.NavGroup
					parentTextVarient={null}
					parentTargetPath={'/schedule_adjust'}
					parentId={'schedule_adjust'}
					parentIcon={'clipboard'}
					parentLinkText={'Schedule Adjust'}
					history={history}
					path={history.location.pathname}
					default={'closed'}
					badge={this.props.badges.hasOwnProperty('pending_tors')}
					badge_color={"warning"}
					badge_text={this.props.badges?.pending_tors}
				/>}
				{roles.some(role => [UserRoles.Dispatch, UserRoles.FieldEngineer, UserRoles.HelpDesk, UserRoles.Hiring].includes(role)) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/pay_center'}
						parentId={'paycenter'}
						parentIcon={'clipboard'}
						parentLinkText={'Pay Center'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
						badge={this.props.badges.hasOwnProperty('final_numbers')}
						badge_color={"success"}
						badge_text={"!"}
					>
						{roles.includes(UserRoles.FieldEngineer) ?
							<Framework.Elements.NavGroup
								parentTextVarient={null}
								parentTargetPath={'/engineers/weekly_estimates'}
								parentId={'engineerestimates'}
								parentIcon={'tachometer'}
								parentLinkText={'Weekly Estimates'}
								history={history}
								path={history.location.pathname}
								default={'closed'}
							/> : <></>
						}
					</Framework.Elements.NavGroup>
				}
				{/*{roles.some(role => [UserRoles.Admin, UserRoles.Executive, UserRoles.Manager, UserRoles.Dispatch, UserRoles.Hiring, UserRoles.HelpDesk, UserRoles.TORManager].includes(role)) &&*/}
				{/*	<Framework.Elements.NavGroup*/}
				{/*		parentTextVarient={null}*/}
				{/*		parentTargetPath={'/idle_tasks'}*/}
				{/*		parentId={'idletasks'}*/}
				{/*		parentIcon={'clipboard'}*/}
				{/*		parentLinkText={'Idle Tasks'}*/}
				{/*		history={history}*/}
				{/*		path={history.location.pathname}*/}
				{/*		default={'closed'}*/}
				{/*	/>*/}
				{/*}*/}
				{roles.some(role => [UserRoles.Admin, UserRoles.Financial].includes(role)) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/pay_center_admin'}
						parentId={'paycenteradmin'}
						parentIcon={'clipboard'}
						parentLinkText={'Pay Center Admin'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
						badge={this.props.badges.hasOwnProperty('pendings')}
						badge_color={"warning"}
						badge_text={this.props.badges.hasOwnProperty('pendings') ? this.props.badges.pendings : ""}
					>
						<li>
							<Link data-id={'pay_center_admin'} variant={"text"} to="/pay_center_admin">
								<i className="fa fa-clipboard"/>
								<span className="nav-text"> Pay Center Admin</span>
							</Link>
						</li>
						<li>
							<Link data-id={'financials_fe_weekly_audit'} variant={"text"} to="/financial/fe_weekly_audit">
								<i className="fa fa-archive"/>
								<span className="nav-text"> FE Weekly Audit</span>
							</Link>
						</li>
					</Framework.Elements.NavGroup>
				}


				{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.HelpDesk].includes(role)) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/customers'}
						parentId={'customers'}
						parentIcon={'user'}
						parentLinkText={'Customers'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
					>
						<li>
							<Link data-id={'dispatch'} variant={"text"} to="/customers/logs">
								<i className="fa fa-archive"/>
								<span className="nav-text">Customers Log</span>
							</Link>
						</li>
					</Framework.Elements.NavGroup>
				}

				{roles.some(role => [UserRoles.Admin, UserRoles.Executive, UserRoles.Manager, UserRoles.HelpDesk].includes(role)) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/refunds'}
						parentId={'refunds'}
						parentIcon={'user'}
						parentLinkText={'Refunds'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
					/>
				}

				{roles.includes(UserRoles.Admin) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/regions'}
						parentId={'regions'}
						parentIcon={'map'}
						parentLinkText={'Regions'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
					>
						<li>
							<Link data-id={'region_feedback_list'} variant={"text"} to="/regions/feedback_list">
								<i className="fa fa-archive"/>
								<span className="nav-text">Feedback List</span>
							</Link>
						</li>
						<li>
							<Link data-id={'region_feedback'} variant={"text"} to="/regions/feedback">
								<i className="fa fa-archive"/>
								<span className="nav-text">Region Feedback</span>
							</Link>
						</li>
					</Framework.Elements.NavGroup>
				}

				{roles.some(role => USER_DIRECTORY_ROLES.includes(role)) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/users'}
						parentId={'users'}
						parentIcon={'users'}
						parentLinkText={'Users'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
						badge={this.props.badges.hasOwnProperty('dd_info_updated')}
						badge_color={"warning"}
						badge_text={this.props.badges.hasOwnProperty('dd_info_updated') ? this.props.badges.dd_info_updated : ""}
					>
						{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Developer, UserRoles.Dispatch, UserRoles.HelpDesk].includes(role)) &&
						<li>
							<Link data-id={'dispatch'} variant={"text"} to="/users/feradius">
								<i className="fa fa-archive"/>
								<span className="nav-text">FE Radius Map</span>
							</Link>
						</li>
						}
					</Framework.Elements.NavGroup>
				}

				{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.HelpDesk].includes(role)) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/phone'}
						parentId={'phone'}
						parentIcon={'phone'}
						parentLinkText={'Phone Logs'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
					>
						{roles.some(role => [UserRoles.Admin, UserRoles.Manager].includes(role)) ?
							<>
								<li>
									<Link data-cy={'phoneLogs_new'} variant={'text'} to="/phone/new">
										<i className="fa fa-globe"/>
										<span className="nav-text">New Phone Log</span>
									</Link>
								</li>
								<li>
									<Link data-cy={'phoneLogs_regions'} variant={'text'} to="/phone/regions">
										<i className="fa fa-globe"/>
										<span className="nav-text">By Region</span>
									</Link>
								</li>
								<li>
									<Link data-cy={'phoneLogs_users'} variant={'text'} to="/phone/users">
										<i className="fa fa-user"/>
										<span className="nav-text">By User</span>
									</Link>
								</li>
							</> : null}
					</Framework.Elements.NavGroup>
				}


				{roles.some(role => [UserRoles.Admin, UserRoles.Executive, UserRoles.Manager, UserRoles.FieldEngineer, UserRoles.HelpDesk].includes(role)) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/stripe'}
						parentId={'stripe'}
						parentIcon={'stripe'}
						parentLinkText={'Sales'}

						history={history}
						path={history.location.pathname}
						default={'closed'}
					/>}


				{roles.some(role => [UserRoles.Admin, UserRoles.Manager].includes(role)) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/financial'}
						parentId={'financial'}
						parentIcon={'credit-card'}
						parentLinkText={'All Financials'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
					>
						<li>
							<Link data-id={'financials_audit_work_orders'} variant={"text"} to="/financial/audit_work_orders">
								<i className="fa fa-archive"/>
								<span className="nav-text"> Audit Work Orders</span>
							</Link>
						</li>
						<li>
							<Link data-id={'financials_pending'} variant={"text"} to="/financial/pendings">
								<i className="fa fa-exclamation"/>
								<span className="nav-text"> Pending Financials</span>
							</Link>
						</li>
						<li>
							<Link data-id={'financials_logs'} variant={"text"} to="/financial/logs">
								<i className="fa fa-archive"/>
								<span className="nav-text"> Financials Logs</span>
							</Link>
						</li>
						<li>
							<Link data-id={'financials_work_orders'} variant={"text"} to="/financial/work_orders">
								<i className="fa fa-archive"/>
								<span className="nav-text"> Work Orders</span>
							</Link>
						</li>
					</Framework.Elements.NavGroup>
				}

				{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.HelpDesk].includes(role)) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/copyables'}
						parentId={'copyables'}
						parentIcon={'tachometer'}
						parentLinkText={'Copyables'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
					/>}

				{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.HelpDesk].includes(role)) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/videos'}
						parentId={'videos'}
						parentIcon={'tachometer'}
						parentLinkText={'Videos'}
						history={history}
						path={history.location.pathname}
						default={'closed'}>
						{roles.some(role => [UserRoles.Admin].includes(role)) ? <li>
							<Link data-id={'dispatch'} variant={"text"} to="/videos/categories">
								<i className="fa fa-archive"/>
								<span className="nav-text">Manage Categories</span>
							</Link>
						</li> : null
						}
					</Framework.Elements.NavGroup>}

				{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.Executive].includes(role)) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/accolades'}
						parentId={'accolades'}
						parentIcon={'ticket'}
						parentLinkText={'Accolades'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
					>
						{roles.includes(UserRoles.Dispatch) ? <li>
							<Link data-id={'dispatch'} variant={"text"} to="/accolades/self">
								<i className="fa fa-archive"/>
								<span className="nav-text">Your Accolades</span>
							</Link>
						</li> : null}
					</Framework.Elements.NavGroup>
				}

				{roles.some(role => [UserRoles.Admin].includes(role)) && <Framework.Elements.NavGroup
					parentTextVarient={null}
					parentTargetPath={'/scores'}
					parentId={'scores'}
					parentIcon={'tachometer'}
					parentLinkText={'Scores'}
					history={history}
					path={history.location.pathname}
					default={'closed'}/>}
				{/*<>
						{roles.some(role => [UserRoles.Admin, UserRoles.Manager].includes(role)) ? <li>
							<Link data-id={'dispatch'} variant={"text"} to="/scores/highs">
								<i className="fa fa-archive"/>
								<span className="nav-text">High Scores</span>
							</Link>
						</li> : null
						}
						{roles.some(role => [UserRoles.Admin].includes(role)) ? <li>
							<Link data-id={'dispatch'} variant={"text"} to="/scores/manager">
								<i className="fa fa-archive"/>
								<span className="nav-text">Manage Scores</span>
							</Link>
						</li> : null
						}
					</>
				</Framework.Elements.NavGroup>}*/}


				{!roles || (roles && roles[0] !== 60) || (roles && roles[0] !== 500) && <Framework.Elements.NavGroup
					parentTextVarient={null}
					parentTargetPath={'/kt_forms'}
					parentId={'kt_forms'}
					parentIcon={'book'}
					parentLinkText={'All Forms'}
					history={history}
					path={history.location.pathname}
					default={'closed'}
				>
					<li>
						<Link variant={"text"} to="/kt_forms/computer_repair_waivers">
							<i className={"fa fa-file"}/>
							<span className="nav-text">Computer Repairs</span>
						</Link>
					</li>
					<li>
						<Link variant={"text"} to="/kt_forms/refund_agreements">
							<i className={"fa fa-file"}/>
							<span className="nav-text">Refunds</span>
						</Link>
					</li>
					<li>
						<Link variant={"text"} to="/kt_forms/completion_certificates">
							<i className={"fa fa-file"}/>
							<span className="nav-text">Completions</span>
						</Link>
					</li>
					<li>
						<Link variant={"text"} to="/kt_forms/data_backup_waivers">
							<i className={"fa fa-file"}/>
							<span className="nav-text">Data Backups</span>
						</Link>
					</li>
					<li>
						<Link variant={"text"} to="/kt_forms/hard_drive_inspection_waivers">
							<i className={"fa fa-file"}/>
							<span className="nav-text">Hard Drive Inspections</span>
						</Link>
					</li>
					<li>
						<Link variant={"text"} to="/kt_forms/anti_virus_inspection_waivers">
							<i className={"fa fa-file"}/>
							<span className="nav-text">Anti Virus Inspections</span>
						</Link>
					</li>
					<li>
						<Link variant={"text"} to="/kt_forms/network_inspection_waivers">
							<i className={"fa fa-file"}/>
							<span className="nav-text">Network Inspections</span>
						</Link>
					</li>
				</Framework.Elements.NavGroup>}


				{roles.some(role => [UserRoles.Dispatch].includes(role)) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/timetracking'}
						parentId={'timetracking'}
						parentIcon={'clipboard'}
						parentLinkText={'Clock Ins/Outs'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
					/>
				}
				{roles.some(role => [UserRoles.Dispatch, UserRoles.Hiring, UserRoles.HelpDesk].includes(role)) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/timetracking/self'}
						parentId={'timetrackingself'}
						parentIcon={'clipboard'}
						parentLinkText={'Time Tracking'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
					/>
				}

				{roles.some(role => [UserRoles.Dispatch, UserRoles.Hiring, UserRoles.HelpDesk, UserRoles.Manager, UserRoles.TORManager, UserRoles.Feedback].includes(role)) &&
					<Framework.Elements.NavGroup
						parentTextVarient={null}
						parentTargetPath={'/schedule_approvals/self'}
						parentId={'scheduleapprovals'}
						parentIcon={'clipboard'}
						parentLinkText={'Approve Schedule'}
						history={history}
						path={history.location.pathname}
						default={'closed'}
					/>
				}
			</>
		);
	}
}

export default withRouter(SidebarContent);
